<template>
  <div>
    <b-table
        show-empty
        stacked="md"
        :striped="true"
        :bordered="true"
        :fields="fields"
        :items="teamMembers"
        :tbody-tr-class="trClass"
        :current-page=0
        class="mt-2">

      <template #cell(nick)="data">
        <div>{{ data.item.username }}</div>
      </template>
      <template #cell(pubg_nick)="data">
        <div>
          {{
            Object.keys(data.item.gameProfiles)?.length === 0 ? 'нет игрового профиля' :
                data.item.gameProfiles.find((profile) => profile.game.slug === 'pubg-mobile')?.fields.nick
          }}
        </div>
      </template>
      <template #cell(pubg_id)="data">
        <div>
          {{
            Object.keys(data.item.gameProfiles)?.length === 0 ? 'нет игрового профиля' :
                data.item.gameProfiles.find((profile) => profile.game.slug === 'pubg-mobile')?.fields.pubg_id
          }}
        </div>
      </template>
      <template #cell(status)="data">
        <div>{{data.item.gameProfiles?.length <= 0 ? 'Не игровой/' : 'Игровой/'}}</div>
        <div>{{data.item.verified_social_accounts_count <= 0 ? 'Не активирован' : 'Активирован'}}</div>
      </template>
      <template #cell(country)="data">
        <div>{{ data.item?.country ? data.item?.country?.name : 'не указано' }}</div>
      </template>
      <template #cell(socials)="data">
        <div v-for="account in data.item?.socialAccounts" :key="'account-' + account.id">
          <div v-if="isShowProvider(account)">
            <a target="_blank"
               :href="getAccountsLink(account.provider, account).provider">
              {{ account.provider }}
            </a>
          </div>
        </div>
      </template>
      <template #cell(role)="data">
        <div class=" mb-2">{{ data.item.role_in_team.name }}</div>
        <div>
          <b-dropdown variant="primary" id="dropdown-1" text="Выбрать роль" class="">
            <b-dropdown-item>
              <b-btn variant="primary"
                     @click.prevent="changeMemberRole({ teamId:$route.params.id, userId:data.item.id, roleId:2 })"
                     :id="'makeMember' + data.item.id"
              >
                Назначить игроком
              </b-btn>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-btn variant="primary"
                     @click.prevent="changeMemberRole({ teamId:$route.params.id, userId:data.item.id, roleId:3 })"
                     :id="'makeManager' + data.item.id"
              >
                Назначить менеджером
              </b-btn>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-btn variant="primary"
                     @click.prevent="changeMemberRole({ teamId:$route.params.id, userId:data.item.id, roleId:1 })"
                     :id="'makeOwner' + data.item.id"
              >
                Назначить владельцем
              </b-btn>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
      <template #cell(inspect)="data">
        <div class="d-flex">
          <b-btn variant="primary" class="p-1 mr-1" @click="showUserInfo(data.item.id)"><i
              class="fa fa-eye"></i></b-btn>
          <b-btn variant="danger" class="p-1" @click="openKickMemberModal(data.item)"
                 :title="`Удалить ${data.item.username} из команды`">
            <i class="fa fa-user-times"></i>
          </b-btn>
        </div>
      </template>
    </b-table>

    <b-modal centered id="modal-pubg-kick-member" title="Удаление игрока из команды"
             v-model="isShowKickMemberModal" hide-footer>
      <div>
        <p>Вы действительно хотите удалить игрока
          <strong>{{ kickMemberTarget && kickMemberTarget.username }}</strong>
          из команды?
        </p>
        <b-alert v-if="kickMemberError" show variant="danger">{{ kickMemberError }}</b-alert>
        <div class="d-flex justify-content-end mt-3">
          <b-btn variant="secondary" class="mr-2" @click="isShowKickMemberModal = false" :disabled="isKickingMember">
            Отмена
          </b-btn>
          <b-btn variant="danger" @click="confirmKickMember" :disabled="isKickingMember">
            {{ isKickingMember ? 'Удаляем...' : 'Удалить' }}
          </b-btn>
        </div>
      </div>
    </b-modal>
  </div>
</template>


<script>
import {UsersAdapterMixin} from "@/mixins/Users/UsersAdapterMixin";
import {TeamsAdapterMixin} from "@/mixins/Teams/TeamsAdapterMixin";
import {ACCOUNTS} from '@/constants/SocialAccounts/providers';
import api from "@/api/api";

export default {
  name: 'PubgPlayerTable',
  mixins: [UsersAdapterMixin, TeamsAdapterMixin],
  props: {
    teamMembers: {
      type: Array,
      required: true
    },
    trClass: {
      required: true,
      type:  [String, Function]
    }
  },

  data() {
    return {
      fields: [
        {key: 'id', label: '№',},
        {key: 'nick', label: 'Nick',},
        {key: 'pubg_nick', label: 'Pubg nick'},
        {key: 'pubg_id', label: 'Pubg id',},
        {key: 'status', label: 'Cтатус',},
        {key: 'country', label: 'Страна',},
        {key: 'socials', label: 'Социальные сети',},
        {key: 'role', label: 'Роль',},
        {key: 'inspect', label: 'Просмотр',},
      ],
      isShowKickMemberModal: false,
      isKickingMember: false,
      kickMemberTarget: null,
      kickMemberError: null,
    }
  },
  methods: {
    getAccountsLink(provider, userDataForLink) {
      if (provider === 'discord') return { provider: `${ACCOUNTS[provider]}${userDataForLink.provider_id}`}
      if (provider === 'telegram') return { provider: `${ACCOUNTS[provider]}${userDataForLink.data.username}`}
      if (provider === 'email') return { provider: `${ACCOUNTS[provider]}${userDataForLink.data.email}`}
      if (provider === 'google') return { provider: `${ACCOUNTS[provider]}${userDataForLink.provider_id}`}
      return { provider: `${ACCOUNTS[provider]}${userDataForLink.provider_id}`}
    },
    isShowProvider(account) {
      return !['phone', 'whatsapp'].includes(account.provider)
    },
    openKickMemberModal(member) {
      this.kickMemberTarget = member;
      this.kickMemberError = null;
      this.isShowKickMemberModal = true;
    },
    async confirmKickMember() {
      if (!this.kickMemberTarget) return;
      this.isKickingMember = true;
      this.kickMemberError = null;
      try {
        await api.teams.deleteTeamMember(this.$route.params.id, this.kickMemberTarget.id);
        this.isShowKickMemberModal = false;
        this.$bvToast.toast('Игрок успешно удалён из команды', {
          title: 'Успех',
          variant: 'success',
          solid: true
        });
        await this.showTeams(this.$route.params.id);
      } catch (error) {
        this.kickMemberError = error?.response?.data?.message || 'Не удалось удалить игрока';
      } finally {
        this.isKickingMember = false;
      }
    },
  }
}
</script>
